/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { TasksApiConfiguration as __Configuration } from '../tasks-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ListQueryResultEnumRefInfo } from '../models/list-query-result-enum-ref-info';
@Injectable({
  providedIn: 'root',
})
class TaskSideService extends __BaseService {
  static readonly GetAllPath = '/api/tasks/task-sides';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return Success
   */
  GetAllResponse(): __Observable<__StrictHttpResponse<ListQueryResultEnumRefInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/tasks/task-sides`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListQueryResultEnumRefInfo>;
      })
    );
  }
  /**
   * @return Success
   */
  GetAll(): __Observable<ListQueryResultEnumRefInfo> {
    return this.GetAllResponse().pipe(
      __map(_r => _r.body as ListQueryResultEnumRefInfo)
    );
  }
}

module TaskSideService {
}

export { TaskSideService }
